'use client';

import { useConsent } from './ConsentProvider';

type CookiePreferencesLinkProps = {
  className?: string;
  label?: string;
};

export default function CookiePreferencesLink({
  className = 'it-footer-outer-link text-decoration-none underlineText after:bottom-1',
  label = 'Preferenze cookie',
}: CookiePreferencesLinkProps) {
  const { openPreferences } = useConsent();

  return (
    <button
      type="button"
      className={`asst-cookie-prefs-link ${className}`.trim()}
      onClick={openPreferences}
    >
      {label}
    </button>
  );
}
